import { AfterViewInit, ChangeDetectionStrategy, Component, OnChanges, OnDestroy, OnInit, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Title } from '@angular/platform-browser';
import { faEdit, faTrash, faCommentSlash, faMessage, faFilePen, faFileArrowDown, faWarning, faLock, faCheck } from '@fortawesome/free-solid-svg-icons';
import { ReportService } from 'src/app/services/report.service';
import { UserService } from 'src/app/services/user.service';
import { DeleteCommentComponent } from '../../delete-comment/delete-comment.component';
import { NewCommentComponent } from '../../new-comment/new-comment.component';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { DialogService } from 'src/app/services/dialog.service';
import { SignReportComponent } from './sign-report/sign-report.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { PrintReport25008Component } from '../print-report/print-report-2500-8.component';
import { ReportForest } from 'src/app/models/reportForest.model';
import { ForestTreament } from 'src/app/models/forestTreatment.model';
import { TreamentSpecification } from 'src/app/models/forestSpecification.model';
import { AuthMethodEnum } from 'src/app/models/enum/auth-method.enum';
import { PrintReportFundingComponent } from '../../funding/print-report-funding/print-report-funding.component';

@Component({
  selector: 'app-view-report-2500-8',
  templateUrl: './view-report-2500-8.component.html',
  styleUrls: ['./view-report-2500-8.component.scss', '../../report-comments.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class ViewReport25008Component implements OnChanges, OnInit, OnDestroy, AfterViewInit {
  //icons
  faEdit = faEdit;
  faTrash = faTrash;
  faCommentSlash = faCommentSlash;
  faMessage = faMessage;
  faFile = faFilePen;
  faFileArrowDown = faFileArrowDown;
  faWarning = faWarning;
  faLock = faLock;
  faCheck = faCheck;

  report_id = input.required<number>();
  report_page_input = input<string>();
  page = input<string>();
  section = input<string>();
  section_nav: string | undefined = undefined;
  report_page: number = 0;
  updateReportSubject = new Subject<any>();
  readyStatus = new Subject<boolean>();
  readyStatusBoolean = false;
  loSelected = new Subject<boolean>();
  loSelectedBoolean = false;
  requiresWOFunding = false;

  report: any;
  report_status: any;
  nav: string = '';
  comment_expand: boolean = false;
  comments: any;
  comments_unresolved: boolean = false;
  reportSections: any;
  sidebar_expand: boolean = true;

  currentUser: any;
  is_roco: boolean = false;
  is_co: boolean = false;
  is_lo: boolean = false;
  is_woco: boolean = false;
  editable: boolean = false;
  canEdit: boolean = false;
  signable: boolean = false;
  submitable: boolean = false;
  autosave: any = { saving: false, saved: false, saveTime: new Date(), updateTimer: new Subject() };
  lockStatus = {
    regionalFunds: true,
    regionalApproval: true,
    woFunds: true,
    woApprovals: true,
  }
  saveTimerID: any = null;
  savedText = "Last Saved a Few Seconds Ago"

  pages = [
    { name: "Report Type", id: "report-type" },
    { name: "Burned Area Description", id: "burned-area" },
    { name: "Watershed Condition", id: "watershed-condition" },
    { name: "Summary of Analysis", id: "analysis-summary" },
    { name: "Recommended Treatment Narratives", id: "recommended-treatment" },
    { name: "Emergency Stabilization Treatments & Requested Funds", id: "emergency-stabilization" },
    { name: "Team & Supporting Documents", id: "team-supporting" },
    { name: "Select Forest Unit Line Officer(s)", id: "select-line-officer" },
  ]
  loaded = [false, false, false, false, false, false, false, false]

  report_type = "funding"

  constructor(
    public dialog: MatDialog,
    private readonly titleService: Title,
    private readonly reportService: ReportService,
    private readonly userService: UserService,
    private readonly toast: ConfirmationToastComponent,
    private readonly dialogService: DialogService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    this.titleService.setTitle("BAER - Report");
    this.reportSections = this.reportService.getReportPageList();
    this.readyStatus.subscribe((value: boolean) => {
      this.readyStatusBoolean = value
    })
    this.loSelected.subscribe((value: boolean) => {
      this.loSelectedBoolean = value
    })
    this.saveTimerID = setInterval(() => {
      this.updateTimer()
    }, 10000);
    this.autosave.updateTimer.subscribe(() => {
      this.updateTimer()
    })
  }

  ngOnInit(): void {
    this.updateReportSubject.subscribe((res: any) => {
      if (res == null) {
        this.getReport(true)
      }
    })
  }

  subLoaded(page: any) {
    this.loaded[page - 1] = true;
    const allLoaded = this.loaded.reduce((acc, val) => acc && val, true);
    if (allLoaded) {
      this.scrollIntoView(this.page() ?? '', (this.section_nav ?? this.section()))
    }
  }

  ngOnChanges(): void {
    this.getReport();
  }

  ngAfterViewInit(): void {
    this.scrollIntoView(this.page() ?? '', (this.section_nav ?? this.section()))
  }

  updateReportType(report: any) {
    if (report.report_type != this.report_type) {
      this.report_type = report.report_type

      if (this.report_type == "No Treatment") {
        this.pages = [
          { name: "Report Type", id: "report-type" },
          { name: "Burned Area Description", id: "burned-area" },
          { name: "Watershed Condition", id: "watershed-condition" },
          { name: "Summary of Analysis", id: "analysis-summary" },
          { name: "Assessment Cost", id: "assessment-cost" },
          { name: "Team & Supporting Documents", id: "team-supporting" },
          { name: "Forest Unit Line Officer Approvals", id: "select-line-officer" },
        ]
      } else if (this.report_type == "Pre-assessment Request") {
        this.loaded[2] = true;
        this.pages = [
          { name: "Report Type", id: "report-type" },
          { name: "Burned Area Description", id: "burned-area" },
          { name: "Summary of Analysis", id: "analysis-summary" },
          { name: "Recommended Treatment Narratives", id: "recommended-treatment" },
          { name: "Emergency Stabilization Treatments & Requested Funds", id: "emergency-stabilization" },
          { name: "Team & Supporting Documents", id: "team-supporting" },
          { name: "Forest Unit Line Officer Approvals", id: "select-line-officer" },
        ]
      } else {
        this.pages = [
          { name: "Report Type", id: "report-type" },
          { name: "Burned Area Description", id: "burned-area" },
          { name: "Watershed Condition", id: "watershed-condition" },
          { name: "Summary of Analysis", id: "analysis-summary" },
          { name: "Recommended Treatment Narratives", id: "recommended-treatment" },
          { name: "Emergency Stabilization Treatments & Requested Funds", id: "emergency-stabilization" },
          { name: "Team & Supporting Documents", id: "team-supporting" },
          { name: "Forest Unit Line Officer Approvals", id: "select-line-officer" },
        ]
      }
    }
  }

  /**
   * Conccurent calls so it can be faster
   */
  getReport(reload?: boolean) {
    if (this.report && !reload) return
    this.dialogService.openSpinner();
    let report: any = {}
    let promise1 = new Promise((resolve, reject) => {
      this.reportService.getReport(this.report_id(), ["forests", "forests.ranger_districts", "forests.treatments", "forests.treatments.treatment_specifications", "forests.line_officer"]).subscribe({
        next: (response: any) => {
          let r = response.reports[0]
          report.forests = r.forests
          resolve(null)
        },
        error: (err) => {
          reject(new Error(err))
        },
      });
    })
    let promise2 = new Promise((resolve, reject) => {
      this.reportService.getReport(this.report_id(), ["users", "users.user", "users.skills.skill", "signatures"]).subscribe({
        next: (response: any) => {
          let r = response.reports[0]
          report.users = r.users
          report.signatures = r.signatures
          resolve(null)
        },
        error: (err) => {
          reject(new Error(err))
        },
      });
    })
    let promise3 = new Promise((resolve, reject) => {
      this.reportService.getReport(this.report_id(), ["assessment", "stateCounties", "supporting_files", "watersheds", "soil_burn_severities"]).subscribe({
        next: (response: any) => {
          let r = response.reports[0]
          for (let field in r) {
            report[field] = r[field]
          }
          resolve(null)
        },
        error: (err) => {
          reject(new Error(err))
        },
      });
    })
    Promise.all([promise1, promise2, promise3]).then((result) => {
      this.dialogService.closeSpinner()
      this.updateReportType(report);
      this.report = report;
      this.subLoaded(1);
      this.titleService.setTitle(`BAER - ${this.report.baer_name} (${this.report.report_num}) Report`);
      this.setReportComments();
      this.setReportStatus();
      this.nav = '';
      this.loadUser();
    }).catch((error: any) => {
      this.dialogService.closeSpinner()
      this.toast.openErrorSnackBar(`There was an error loading the report.`, "Please refresh to try again.");
    })
  }

  loadUser() {
    this.editable = this.report.report_status_id != 2; // SUBMITTED
    this.userService.getUserProfile().then(async (user) => {
      this.currentUser = user;
      if ((this.currentUser.isROCO?.length ?? 0) > 0) this.is_roco = true;
      if (this.currentUser.isCO) this.is_co = true;
      if (this.currentUser.isLO) this.is_lo = true;
      if ((this.currentUser.isWOCO?.length ?? 0) > 0) this.is_woco = true;
      let lead_ids = this.report.users.filter((user: any) => user.editor)?.map((x: any) => x.user_id) ?? [];
      lead_ids.push(this.report.assessment.team_lead_id);
      if ((this.currentUser.isWOCO.length >= 1) ||
        lead_ids.includes(user.user_id) ||
        (this.currentUser.isFOCO.includes(this.report.assessment.forest_name)) ||
        (this.currentUser.isROCO.includes(this.report.assessment.region))
      ) this.canEdit = true;

      if (((this.currentUser.isWOCO.length >= 1) || (this.currentUser.isROCO.includes(this.report.assessment.region))) && [0, 1, 2, 3].includes(this.report.authorization_status_id))
        this.editable = true;
      this.updateSignable()
      this.updateLockStatus()
    });
  }

  save_close() {
    this.nav = 'close'
  }

  forward() {
    this.nav = 'forward'
  }

  back() {
    this.nav = 'back'
  }

  updateSignable() {
    this.signable = false
    this.submitable = false
    if (this.report.report_status_id == 2) {
      this.checkAuthStatus();
    }
  }

  checkAuthStatus() {
    switch (this.report.authorization_status_id) {
      case 0: // FOLO signature requested
        if (this.currentUser.isFOLO) {
          let forests: string[] = this.currentUser.baer_roles.filter((role: any) => role.baer_role.type == "FOLO").map((role: any) => (role.forest_name ?? this.currentUser.forest_name))
          this.signable = this.report.forests.find((forest: any) => forests.includes(forest.forest_name))
        }
        break;
      case 1: // ROLO signature requested
        if (this.currentUser.isROLO && (this.section_nav ?? this.section()) == 'regional_funds') {
          let regions: string[] = this.currentUser.baer_roles.filter((role: any) => role.baer_role.type == "ROLO").map((role: any) => (role.region ?? this.currentUser.region))
          this.signable = this.report.forests.find((forest: any) => regions.includes(forest.region))
          let signature = this.report.signatures?.find((signature: any) =>
            signature.signature == "Pending Signature"
            && signature.signature_type_id == 1
            && this.currentUser.user_id == signature.user_id
          )
          if (signature) this.signable = true
        }
        break;
      case 2: // WO signature requested
        if (this.currentUser.isWOLO && (this.section_nav ?? this.section()) == 'wo_funds')
          this.signable = true
        break;
      case 3: // Review RO funding
        if (this.currentUser.isROCO && (this.section_nav ?? this.section()) == 'regional_funds') {
          let regions: string[] = this.currentUser.baer_roles.filter((role: any) => role.baer_role.type == "ROCO").map((role: any) => (role.region ?? this.currentUser.region))
          this.submitable = this.report.forests.find((forest: any) => regions.includes(forest.region))
        }
        break;
      case 5: // Review WO funding
        if (this.currentUser.isWO && (this.section_nav ?? this.section()) == 'wo_funds')
          this.submitable = true
        break;
      case 6: // done
        break;
    }
  }

  setReportComments() {
    this.reportService.getReportComments(this.report_id()).subscribe((reportComments: any) => {
      this.comments = reportComments.reportCommentEntities;
      let findUnresolved = this.comments.find((x: any) => !x.resolved)
      if (findUnresolved ?? false) this.comments_unresolved = true;
    })
  }

  setReportStatus() {
    //TODO
    //true - complete
    //false - incomplete
    this.report_status = [
      { report_page: 1, status: false },
      { report_page: 2, status: false },
      { report_page: 3, status: false },
      { report_page: 4, status: false },
      { report_page: 5, status: false },
      { report_page: 6, status: false },
      { report_page: 7, status: false },
      { report_page: 8, status: false }
    ]
    this.setPage();
  }

  setPage() {
    //if no page passed in, set page to latest page not finished
    if (this.report_page_input()) {
      this.report_page = (Number.parseInt(this.report_page_input() ?? '') ?? 0);
    }
    else {
      const filtered_status = this.report_status.filter((status: any) => !(status.status))
      const lowestItem = filtered_status.reduce((prev: any, curr: any) => (prev.report_page < curr.report_page ? prev : curr));
      this.report_page = lowestItem.report_page;
    }
  }

  addComment() {
    this.dialog.open(NewCommentComponent, {
      width: "600px",
      data: {
        'report_num': this.report_page,
        report_id: this.report_id(),
        edit: false,
        user: this.currentUser
      },
      panelClass: ['animate__animated', 'animate__fadeInDown'],
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.setReportComments();
      }
    })
  }

  editComment(comment: any) {
    this.dialog.open(NewCommentComponent, {
      width: "600px",
      data: {
        'report_num': comment.section,
        report_id: this.report_id(),
        comment: comment,
        edit: true,
        user: this.currentUser
      },
      panelClass: ['animate__animated', 'animate__fadeInDown'],
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.setReportComments();
      }
    })
  }

  deleteComment(comment: any) {
    this.dialog.open(DeleteCommentComponent, {
      width: "440px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        comment_id: comment.report_comment_id
      }
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.setReportComments();
      }
    })
  }

  markAsResolved(comment: any, resolved: boolean) {
    this.reportService.editReportComment({
      resolved: resolved
    }, comment.report_comment_id).subscribe({
      next: (response) => {
        comment.resolved = resolved
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error marking commment ${resolved ? 'resolved' : 'unresolved'}`, "Please try again.");
      },
    });
  }

  findPage(pageNum: any) {
    return this.reportSections.find((x: any) => x.pageNum == pageNum).pageName;
  }

  scrollIntoView(elementID: string, section?: string) {
    if (section != (this.section_nav ?? this.section()) && !(section == 'view-report' && (this.section_nav ?? this.section()) == undefined)) {
      this.section_nav = section;
      this.updateSignable();
      this.loaded = [true, false, false, false, false, false, false, false];
      this.router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams: { page: elementID, section: section },
          queryParamsHandling: 'merge'
        }
      )
    } else {
      let element = document.getElementById(elementID)
      element?.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
    }
  }

  submitFunding() {
    let new_status: any = undefined
    let regional_funding_status_id: any = undefined
    let wo_funding_status_id: any = undefined

    if (this.report.authorization_status_id == 3) {
      new_status = 1
      regional_funding_status_id = 2
    } else if (this.report.authorization_status_id == 5) {
      new_status = 2
      wo_funding_status_id = 2
    }



    this.reportService.updateReport({
      report_id: this.report.report_id,
      authorization_status_id: new_status,
      regional_funding_status_id: regional_funding_status_id,
      wo_funding_status_id: wo_funding_status_id,
    }).subscribe({
      next: (response: any) => {
        this.toast.openSuccessSnackBar(`Report successfully submitted for signature.`);
        this.getReport(true);
      },
      error: (response: any) => {
        this.toast.openErrorSnackBar(`There was an error submitting the report`, "Please try again.");
      },
    })
  }

  sign() {
    let signature = ""
    let signType = ""
    if ((this.section_nav ?? this.section()) == 'view-report' || (this.section_nav ?? this.section()) == undefined) {
      signature = this.currentUser.forest_name
      // FIX HERE. The forest_name is not used anymore
      signType = "LO"
    } else if ((this.section_nav ?? this.section()) == 'regional_funds') {
      signature = this.currentUser.region
      signType = "RO"
    } else if ((this.section_nav ?? this.section()) == 'wo_funds') {
      signature = "WO"
      signType = "WO"
    }
    this.dialog.open(SignReportComponent, {
      width: "700px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
      data: {
        report: this.report,
        user: this.currentUser,
        signature: signature,
        signType: signType,
        requiresWOFunding: this.requiresWOFunding,
      }
    }).afterClosed().subscribe((reload) => {
      if (reload) {
        this.getReport(true);
      }
    })
  }

  checkWOFunding() {
    this.requiresWOFunding = false
    this.report.forests.forEach((forest: ReportForest) => {
      forest.treatments!.forEach((treatment: ForestTreament) => {
        treatment.treatment_specifications!.forEach((spec: TreamentSpecification) => {
          // treatment.treatment_option_id 54 is M2
          // treatment.treatment_option_id 55 is M3
          if (treatment.treatment_option_id == 54 || treatment.treatment_option_id == 55
            || spec.ro_authorized_by_id == AuthMethodEnum.FOWARD_TO_WO
            || spec.ro_authorized_by_id == AuthMethodEnum.SPLIT_AUTHORIZATION) {
            this.requiresWOFunding = true
          }
        })
      })
    })
  }

  updateLockStatus() {

    if (this.report.authorization_status_id == 0) { // LO signature requested
      this.report.page_8_status_id = 0
    }

    this.lockStatus = {
      regionalFunds: true,
      regionalApproval: true,
      woFunds: true,
      woApprovals: true,
    }
    if (this.is_roco) {
      this.lockStatus.regionalFunds = false
      this.lockStatus.regionalApproval = false
    }
    if (this.is_lo) {
      this.lockStatus.regionalFunds = false
      this.lockStatus.regionalApproval = false
    }
    if (this.is_woco) {
      this.lockStatus.woFunds = false
      this.lockStatus.woApprovals = false
    }
    if (this.report.authorization_status_id != 1) { // awaiting LO signature
      this.lockStatus.regionalApproval = true // regional lo can't sign off until forest LO sign off
    }
    if (this.report.authorization_status_id != 2) { // awaiting WO signature
      this.lockStatus.woApprovals = true // wo lo can't sign off until forest regional
    }
    if (this.report.authorization_status_id != 3) { //RO FUNDING
      this.lockStatus.regionalFunds = true
    }
    if (this.report.authorization_status_id != 5) {//WO FUNDING
      this.lockStatus.woFunds = true
    }

    if (this.report.regional_approval_status_id == 2) {
      this.lockStatus.regionalApproval = false // unlock if complete
    }
    if (this.report.wo_approval_status_id == 2) {
      this.lockStatus.woApprovals = false // unlock if complete
    }
    if (this.report.regional_funding_status_id == 2) {
      this.lockStatus.regionalFunds = false // unlock if complete
    }
    if (this.report.wo_funding_status_id == 2) {
      this.lockStatus.woFunds = false // unlock if complete
    }
    this.checkWOFunding()
  }

  download() {
    this.dialog.open(PrintReport25008Component, {
      width: "1700px",
      height: "0px",
      data: {
        report_id: this.report_id()
      }
    });
  }

  downloadFunding() {
    this.dialog.open(PrintReportFundingComponent, {
      width: "1700px",
      height: "0px",
      data: {
        report_id: this.report_id()
      }
    });
  }

  updateTimer() {
    let minutes = Math.floor((Date.now() - this.autosave.saveTime.getTime()) / 60000)
    if (minutes < 1) {
      this.savedText = "Last Saved a Few Seconds Ago"
    } else if (minutes == 1) {
      this.savedText = "Last Saved 1 Minute Ago"
    } else if (minutes >= 60 * 24) {
      if (minutes < 60 * 24 * 2) {
        this.savedText = `Last Saved 1 Day Ago`
      } else {
        this.savedText = `Last Saved ${Math.floor(minutes / (60 * 24))} Days Ago`
      }
    } else if (minutes >= 60) {
      if (minutes < 60 * 2) {
        this.savedText = `Last Saved 1 Hour Ago`
      } else {
        this.savedText = `Last Saved ${Math.floor(minutes / (60))} Hours Ago`
      }
    } else {
      this.savedText = `Last Saved ${minutes} Minutes Ago`
    }
  }

  ngOnDestroy() {
    // end timeout when we leave the page
    if (this.saveTimerID) {
      clearInterval(this.saveTimerID);
    }
  }

  checkDisabled() {
    if (!this.readyStatusBoolean || !this.loSelectedBoolean) return 'disabled'
    return ''
  }
}
